/**
 * Quick Actions Strip - 6 key links for instant access from Today Dashboard.
 * No new logic, just navigation shortcuts.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList, MessageCircle, Brain, UtensilsCrossed, Moon, Waves, CircleDot } from 'lucide-react';

const quickActions = [
  { path: '/daily-check-in', label: 'Check-In', icon: ClipboardList },
  { path: '/therapy', label: 'Therappi® AI', icon: MessageCircle },
  { path: '/meditation-library', label: 'Meditate', icon: Brain },
  { path: '/nutrition', label: 'Nutrition', icon: UtensilsCrossed },
  { path: '/sleep-and-dreams', label: 'Sleep', icon: Moon },
  { path: '/telempathy-tools', label: 'Soul Guidance', icon: Waves },
  { path: '/lunar-cycle', label: 'Lunar & Cycle', icon: CircleDot },
];

export const QuickActionsStrip: React.FC = () => {
  return (
    <section className="animate-fade-in">
      <h2 className="text-xs font-medium text-muted-foreground tracking-wider mb-3 uppercase">
        Quick Actions
      </h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-7 gap-2 sm:gap-3">
        {quickActions.map(({ path, label, icon: Icon }) => (
          <Link
            key={path}
            to={path}
            className="flex flex-col items-center gap-1.5 p-3 rounded-xl bg-card/60 hover:bg-card border border-border/40 hover:border-primary/30 transition-all group"
          >
            <div className="w-10 h-10 rounded-full bg-primary/10 group-hover:bg-primary/20 flex items-center justify-center transition-colors">
              <Icon className="h-5 w-5 text-primary" />
            </div>
            <span
              className="text-[11px] sm:text-xs font-medium text-foreground/80 text-center leading-tight"
              dangerouslySetInnerHTML={{ __html: label.replace(/®/g, '<sup class="text-[0.4em]">®</sup>') }}
            />
          </Link>
        ))}
      </div>
    </section>
  );
};
